<template>
  <v-app>
    <v-navigation-drawer app
                         clipped
                         temporary
                         v-model="open"
                         v-if="nav">
      <v-list nav>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Carle FAP Admin
            </v-list-item-title>
            <v-list-item-subtitle v-if="$store.getters.user">
              Welcome, {{ $store.getters.user.userName }}!
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link exact to="/">
          <v-list-item-action>
            <v-icon>home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            Home
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-list nav>
        <template v-for="item in navItems">
          <v-list-group v-if="hasChildren(item) && $store.getters.can(item.can || 'Author')"
                        no-action
                        :prepend-icon="item.icon"
                        :key="item.label">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item link
                         v-for="child in item.children"
                         :to="child.to"
                         :key="child.to.name">
              <v-list-item-icon>
                <v-icon v-text="child.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="child.label"></v-list-item-title>
            </v-list-item>
          </v-list-group>
          <v-list-item link
                       v-else-if="$store.getters.can(item.can || 'Author')"
                       :key="item.to.name"
                       :to="item.to">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              {{ item.label }}
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <v-divider />
      <v-list nav>
        <v-list-item link @click="logout">
          <v-list-item-action>
            <v-icon>logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            Sign Out
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app
               clipped-left
               dark
               color="primary"
               v-if="nav">
      <v-app-bar-nav-icon @click.stop="open = !open" />
      <v-toolbar-title>Carle Find a Provider Administration</v-toolbar-title>
    </v-app-bar>
    <transition :name="transition" mode="out-in">
      <router-view />
    </transition>
    <v-dialog v-model="alert.show" max-width="350">
      <v-card>
        <v-card-title class="headline">{{ alert.heading }}</v-card-title>
        <v-card-text>{{ alert.msg }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="accent"
                 text
                 @click="alert.show = false">
            Got It
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import RouteMeta from '@/components/Mixins/RouteMeta';
import { alert } from '@/components/Mixins/Messages';

export default {
  mixins: [
    RouteMeta,
    alert,
  ],
  data() {
    return {
      open: false,
      navItems: [
        { to: { name: 'provider.index' }, icon: 'apps', label: 'Providers' },
        { to: { name: 'location.index' }, icon: 'domain', label: 'Locations' },
        {
          icon: 'date_range',
          label: 'Scheduling',
          can: 'Admin',
          children: [
            {
              to: { name: 'schedule.index' },
              label: 'Schedules',
              icon: 'schedule',
            },
            {
              to: { name: 'day.index' },
              label: 'Holidays',
              icon: 'event',
            },
          ],
        },
        { to: { name: 'media.index' }, icon: 'image', label: 'Media' },
        {
          to: { name: 'place.index' },
          icon: 'near_me',
          label: 'Places',
          can: 'Editor',
        },
        {
          to: { name: 'country.index' },
          icon: 'public',
          label: 'Countries',
          can: 'Editor',
        },
        { to: { name: 'tag.index' }, icon: 'local_offer', label: 'Tags' },
        { to: { name: 'user.index' }, icon: 'person', label: 'Users' },
      ],
    };
  },
  methods: {
    logout() {
      this.open = false;
      this.$store.dispatch('logout');
      this.$router.push({ name: 'login' });
    },
    checkAlert() {
      if (this.$route.query.error === 'unauthorized') {
        this.openAlert('Unauthorized', 'You do not have permission to view the requested area. Please contact an Administrator for more details.');
      }
    },
    hasChildren(item) {
      return 'children' in item;
    },
  },
  watch: {
    $route(to, from) {
      this.setNav();
      this.setTransition(to, from);
      this.checkAlert();
    },
  },
  mounted() {
    this.setNav();
    this.checkAlert();
  },
};
</script>
